'use client'

import React, {useState} from "react";
import {CSSTransition} from 'react-transition-group';
import Image from 'next/image'

export default function FaqItem(props) {
    const header = props.header;
    const [isOpen, setIsOpen] = useState(false);
    return (
        <>
            <li className={isOpen ?"q open":"q"} onClick={() => setIsOpen(!isOpen)}>
                {
                    isOpen ? <Image src="/images/arrow-expand.png" width={14} height={8}/> :
                        <Image src="/images/arrow-collapse.png" width={8} height={14}/>
                }

                &nbsp;&nbsp;{header}
            </li>
            <CSSTransition in={isOpen} timeout={100} classNames="faqItem">
                <li className="faqText faqItem-exit-done">
                    {props.children}
                </li>
            </CSSTransition>
        </>
    )
}

